export default __webpack_public_path__ + "static/media/right-hammer.30222c84.png";